<template>
  <!-- 水滴图 -->
  <div :ref="refId" :datas="datas" style="width: 100%; height: 100%"></div>
</template>

// refId 图表id // datas 图表数据源 // colorName 看取那个色值的名称

<script>
import 'echarts-liquidfill';

export default {
  props: ['refId', 'datas', 'colorName'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue, oldValue) {
        this.setPieOption(this.refId, newValue, this.colorName);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas >= 0) {
      this.setPieOption(this.refId, this.datas, this.colorName);
    }
  },
  methods: {
    setPieOption(refId, datas, colorName) {
      const ratio = datas; // 占比数值  总数为100
      const ratioLength = 3; // 波浪数量
      const ratioArr = [];
      let ratioColor = []; // 波浪内颜色
      if (colorName == 1) {
        ratioColor = [
          '#3B86FF',
          '#5697FF',
          '#3FBBFE',
          '#66CAFE',
          '#7F88FE',
          '#BBA8FF',
          '#CACEFE',
          '#A3FFF8',
          '#63D0FF',
          '#82DAFF',
          '#4FC9FC',
          '#8EF1FF',
          '#6DD0D8',
          '#9FD5FF',
          '#79C6F8',
          '#31D8F8',
          '#11CBFF',
          '#6ACFFF',
          '#64BFFF',
          '#5093FF',
          '#FFCBD1',
        ]; // 蓝色
      } else {
        ratioColor = [
          '#FD398E',
          '#FE6695',
          '#FE80A7',
          '#FBBBD7',
          '#FED0E4',
          '#FCDFF3',
          '#FFB1E7',
          '#FFA5D5',
          '#FF98B7',
          '#FEAAA0',
          '#FFBFAF',
          '#FFD1A2',
          '#FBE0BD',
          '#FEFFDF',
          '#FFDEE6',
          '#FFBFDB',
          '#FFD1E4',
          '#FCD4D8',
          '#FFAFC2',
          '#FF6D9F',
          '#FFCBD1',
        ]; // 粉色
      }
      for (let ratioIndex = 0; ratioIndex < ratioLength; ratioIndex++) {
        ratioArr.push(ratio / 100);
      }

      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        // backgroundColor: '#003366',
        title: {
          text: `${ratio}%`,
          textStyle: {
            fontSize: 40,
            fontFamily: 'Microsoft Yahei',
            fontWeight: 'bold',
            color: '#fff',
          },
          x: 'center',
          y: 'center',
        },
        series: [
          {
            type: 'liquidFill',
            radius: '78%',
            center: ['50%', '50%'],
            color: ratioColor,
            data: ratioArr,
            backgroundStyle: {
              // borderWidth: 1,
              color: '#1f2c52',
            },
            label: {
              normal: {
                formatter: '',
              },
            },
            outline: {
              show: false,
            },
          },
          {
            // 细的外圈
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['81%', '86%'],
            hoverAnimation: false,
            data: [
              {
                name: '',
                value: 50,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: 'transparent',
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              },
              {
                // 画剩余的刻度圆环
                name: '',
                value: 50,
                itemStyle: {
                  color: 'rgba(64, 80, 118, 0.5)',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: 'rgba(64, 80, 118, 0.5)',
                  },
                },
              },
            ],
          },
          {
            // 粗的外圈
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['81%', '86%'],
            hoverAnimation: false,
            zlevel: 2,
            data: [
              {
                name: '',
                value: 50,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: ratioColor[0],
                    },
                    {
                      offset: 1,
                      color: ratioColor[3],
                    },
                  ]),
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: ratioColor[0],
                      },
                      {
                        offset: 1,
                        color: ratioColor[3],
                      },
                    ]),
                  },
                },
              },
              {
                // 画剩余的刻度圆环
                name: '',
                value: 50,
                itemStyle: {
                  color: 'transparent',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: 'transparent',
                  },
                },
              },
            ],
          },
        ],
      };
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
</script>

<style scoped></style>
